import React from "react";
import { Box, Profile2User, CloseCircle, Minus, Clock, Refresh, Bag, ImportCircle, Slash } from "iconsax-react";
import type { BadgeColor } from "@/shared/ui";
import { CloseIcon, CheckIcon } from "@/shared/assets/icons";
import type { ItemStatus, ItemRequestStatus, InventorySubtype } from "../types";

export function getWarehouseStatusConfig(status: ItemStatus): {
  color: BadgeColor;
  icon: React.ReactElement | undefined;
} {
  switch (status) {
    case "in_stock":
      return { color: "positive", icon: <Box size={12} color="currentColor" variant="Bold" /> };
    case "assigned":
      return { color: "notice", icon: <Profile2User size={12} color="currentColor" variant="Bold" /> };
    case "written_off":
      return { color: "negative", icon: <CloseCircle size={12} color="currentColor" variant="Bold" /> };
    case "disposed":
      return { color: "negative", icon: <Minus size={12} color="currentColor" variant="Bold" /> };
    default:
      return { color: "gray", icon: undefined };
  }
}

export function getInventorySubtypeConfig(subtype: NonNullable<InventorySubtype>): {
  color: BadgeColor;
  icon: React.ReactElement | undefined;
} {
  switch (subtype) {
    case "consumable":
      return { color: "notice", icon: <Bag size={12} color="currentColor" variant="Bold" /> };
    case "reusable":
      return { color: "info", icon: <Refresh size={12} color="currentColor" variant="Bold" /> };
    default:
      return { color: "gray", icon: undefined };
  }
}

export function getRequestStatusConfig(status: ItemRequestStatus): {
  color: BadgeColor;
  icon: React.ReactElement | undefined;
} {
  switch (status) {
    case "pending":
      return { color: "gray", icon: <Clock size={12} color="currentColor" /> };
    case "approved":
      return { color: "info", icon: <Clock size={12} color="currentColor" /> };
    case "rejected":
      return { color: "negative", icon: <CloseIcon size={12} /> };
    case "fulfilling":
      return { color: "info", icon: <ImportCircle size={12} color="currentColor" /> };
    case "fulfilled":
      return { color: "positive", icon: <CheckIcon /> };
    case "cancelled":
      return { color: "notice", icon: <Minus size={12} color="currentColor" /> };
    case "unavailable":
      return { color: "gray", icon: <Slash size={12} color="currentColor" /> };
    default:
      return { color: "gray", icon: undefined };
  }
}
